import { render, staticRenderFns } from "./addon.vue?vue&type=template&id=bd005c00"
import script from "./addon.vue?vue&type=script&lang=js"
export * from "./addon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports